import MainRouter from './MainRouter';

export default MainRouter;
